import { Button, Container, RadioGroup, FormControlLabel, Radio, Typography, Grid, TextField, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from '@material-ui/core/Checkbox';
import React, { useEffect, useState } from 'react';
import * as azblob from '@azure/storage-blob';


const useStyles = makeStyles((theme) => ({
    root: {
        '& > *': {
            margin: theme.spacing(1),
        },
    },
    input: {
        display: 'none',
    },
}));

const DigiGroeiForm = (props) => {

    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }
        else {
            setInskrywingInfo({ ...inskrywing, "inskrywerId": props.userProf.userProfile.id })
        }

    }, [])


    const classes = useStyles();
    const [status, reportStatus] = useState('Oplaai het begin...');
    const [isUploading, setIsUploading] = useState(false);
    const [formIsInValid, setFormIsInvalid] = useState(true);
    const [isBemagtig, setIsBemagtig] = useState(true);
    const [bewyse, setBewyse] = useState("GEEN");
    const [bewyseOpgelaai, setBewyseOpgelaai] = useState(false)

    const [inskrywing, setInskrywingInfo] = useState({
        "inskrywerId": "",
        "naamVan": "",
        "ouderdom": "",
        "ouerSel": "",
        "ouerEpos": "",
        "sel": "",
        "instansieNaam": "",
        "onderwerp":"",
        "ouerBemagtigingGegee": false,
        "bewyseGelaai": false

    });
    const [inskrywingId, setInskrywingId] = useState();


    const accountName = "projektestorage";
    //const sasString = "?sv=2019-10-10&ss=bfqt&srt=co&sp=rwdlacupx&se=2020-09-01T05:48:33Z&st=2020-06-30T21:48:33Z&spr=https&sig=RnLJvY7Qb7CY%2BPvqbny7KeiDw1EvHvGTwrv7GUNXqr4%3D";
    const sasString = process.env.REACT_APP_STORAGE_ACCOUNT_ACCESS_KEY;                              
    const containerName = "digigroei";
    const containerURL = new azblob.ContainerURL(
        `https://${accountName}.blob.core.windows.net/${containerName}?${sasString}`,
        azblob.StorageURL.newPipeline(new azblob.AnonymousCredential));
    const bewyseInput = document.getElementById("bewyse-input");

    const uploadVidToBlob = async () => {
        //await finishSubmit();
        reportStatus("Besig om op te laai, gee asseblief 1-2 minute tyd...");
        const promises = [];
        for (const file of bewyseInput.files) {
            const blockBlobURL = azblob.BlockBlobURL.fromContainerURL(containerURL, inskrywing.naamVan + "-" + inskrywing.inskrywerId + "-inskrywing-bewyse-" + inskrywingId);
            promises.push(azblob.uploadBrowserDataToBlockBlob(
                azblob.Aborter.none, file, blockBlobURL));
        }
        await Promise.all(promises);
        reportStatus("Sukses!");
        setIsUploading(false);
        window.setTimeout(props.history.push('suksesinskryf'), 1000);
    }


    const style = {

        padding: "20px",
    }


    const formChange = (e) =>
    {
        if (e.target.type === "radio") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.value });
        }
        else if (e.target.type === "checkbox") {
            setInskrywingInfo({ ...inskrywing, [e.target.name]: e.target.checked });

        }
        else {
            setInskrywingInfo({ ...inskrywing, [e.target.id]: e.target.value });
        }
    }

    const bewyseInputChange = () => {
        if (document.getElementById("bewyse-input").value != "") {
            setBewyse("Bewyse van betaling gekies!");
            setBewyseOpgelaai(true);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": true })
        }
        else {
            setBewyse("");
            setBewyseOpgelaai(false);
            setInskrywingInfo({ ...inskrywing, "bewyseGelaai": false })


        }

    }


    const finishRegistration = async () => {
            //start upload ui
            setIsUploading(true);
            //insert record for inskrywing into db
           fetch('api/UserEntries/digigroei/new', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
               },
               body: JSON.stringify(inskrywing)
            })
                .then((response) => response.json())
               .then((data) => {
                   setInskrywingId(data.id);
                   //props.history.push('suksesinskryf')
                   //console.log('data logged as reposne', data);
               })

        }

    useEffect(() => {
        if (inskrywingId !== undefined) {
            //wait for id to be returned before uploading video to azureblob
            //window.alert('BEGIN VIDEOMATERIAAL LAAI, ASSEBLIEF WEES GEDULDIG');
            uploadVidToBlob();
        }
    }, [inskrywingId])


    //unneccessary for production
    useEffect(() => {
        //console.log('loigging props on digipraatform', props);
        console.log('logging inskrywing state', inskrywing);
    }, [])


    useEffect(() => {
        //console.log("DIGIPRAATFORM PROPS:", props);
        if (!props.isAuth.userAuth) {
            props.history.push('tekenin');
        }

    }, [])

    useEffect(() =>
    {
        //as inskrywing verander, kyk of vorm leeg is

        console.log('Inskrywing:', inskrywing);
        var isValid = true;

        for (var property in inskrywing) {
            if (property === "ouerBemagtigingGegee") {
                if (inskrywing["ouerBemagtigingGegee"] === false) {
                    isValid = false;
                }
            }
            else if (property === "bewyseGelaai") {
                if (inskrywing["bewyseGelaai"] === false) {
                    isValid = false;
                }
            }
            else if (inskrywing[property] === "") {
                isValid = false;
            }
            //console.log(`key= ${property} value = ${inskrywing[property]}`)
        }
        if (isValid) {
            setFormIsInvalid(false);
        }
        else {
            setFormIsInvalid(true);
        }


    }, [inskrywing])


    return (
        <Container className="container" style={style}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={6}>
                    <Typography variant="h5" gutterBottom>Jou besonderhede</Typography>

                    <TextField onChange={formChange} id="naamVan" required label="Naam en van" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouderdom" label="Ouderdom" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="ouerEpos" label="E-posadres" variant="outlined" margin="normal" type="email" fullWidth />

                    <TextField onChange={formChange} id="ouerSel" label="Selfoonnommer" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="sel" label="Alternatiewe Kontaknommer" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="instansieNaam" label="Naam van opvoedkundige instansie" variant="outlined" margin="normal" fullWidth />

                    <TextField onChange={formChange} id="onderwerp" label="Tema van webinaar" variant="outlined" margin="normal" fullWidth />

                    <Typography variant="h5" gutterBottom>Ouermagtiging</Typography>
                    <Grid container>
                        <Grid item xs={2} lg={2}>
                            <Checkbox
                                onChange={formChange}
                                color="primary"
                                name="ouerBemagtigingGegee"
                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                            />
                        </Grid>
                        <Grid item xs={10} lg={10}>
                            <Typography variant="h6" gutterBottom>
                                {
                                    //important notice to be ticked
                                }
                                    Hiermee gee ek toestemming dat my kind aan ATKV-DigiGroei mag deelneem. </Typography>
                        </Grid>
                    </Grid>
                    {/* 
                     * Bewys van betaling
                     */}
                    <div className={classes.root}>
                        <Typography variant="h6" gutterBottom>Bewys van betaling</Typography>
                        <Button
                            variant="contained"
                            component="label"
                            color="primary"
                        >
                            Betalingsoplaaifunksie
                        <input
                                id="bewyse-input"
                                type="file"
                                style={{ display: "none" }}
                                onChange={bewyseInputChange}
                                accept=".pdf"

                            />
                        </Button>
                        {bewyseOpgelaai ? <p> {bewyse} </p> : <p> </p>}

                    </div>
                    {/* 
                     * END Bewys van betaling END
                     */}


                </Grid>
                <Grid container justify="center">
                    {isUploading ? <Grid item> <CircularProgress /> <Typography variant="body1" gutterBottom>{status}</Typography> </Grid> : <br />}
                </Grid>

                <Grid container justify="center">
                    <Grid>
                        <Button variant="contained" size="large" color="primary" disabled={formIsInValid} onClick={finishRegistration}>Registreer vir ATKV-DigiGroei</Button>

                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )

}


export default DigiGroeiForm;


// WEBPACK FOOTER //
// ./src/components/inskrywingsvorms/DigiGroeiForm.js